/* T3076 (decision 7390): the gold badge of a site that holds a Tax Exempt certificate, the small pill's measure in the brand gold, its text in the body text colour (white on this gold reads 3.1 to 1, under the 4.5 to 1 floor). Every value a token. */
.badge {
  display: inline-flex;
  align-items: center;
  gap: var(--space-1);
  block-size: var(--pill-height-small);
  margin-inline-start: var(--space-2);
  padding-inline: var(--space-2);
  border-radius: var(--radius-stadium);
  background: var(--gold-accent);
  color: var(--text);
  font-size: var(--font-size-pill-small);
  font-weight: var(--font-weight-bold);
  line-height: 1;
  white-space: nowrap;
  vertical-align: middle;
}

.years {
  font-variant-numeric: tabular-nums;
}
